import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './SetList.css';
import ProgressBar from '../ProgressBar/ProgressBar';
import {HOST} from "../config";

const SetList = () => {
    const [sets, setSets] = useState([]);
    const [booksSummary, setBooksSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        Promise.all([
            fetch(HOST + '/api/sets').then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            }),
            fetch(HOST + '/api/books/summary').then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            }),
        ])
            .then(([setsData, summaryData]) => {
                setSets(setsData);
                setBooksSummary(summaryData);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error fetching sets:', err);
                setError('Failed to fetch flashcard sets.');
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading sets...</div>;
    if (error) return <div>{error}</div>;

    const manualSets = sets.filter(set => set.category !== 'book');
    const hasBooks = booksSummary && booksSummary.books.length > 0;
    const booksTitle = booksSummary?.themes.length === 1 ? booksSummary.themes[0] : 'Books';
    const booksDescription = booksSummary?.books.map(b => b.title.replace(/ Flashcards$/, '')).join(', ');

    return (
        <div className="set-list">
            <h1>Flashcard Sets</h1>
            {hasBooks && (
                <>
                    <h2 className="set-list-section">Books</h2>
                    <ul>
                        <li className="book-tile">
                            <h2>{booksTitle}</h2>
                            <p>{booksDescription}</p>
                            {booksSummary.progress && <ProgressBar {...booksSummary.progress} />}
                            <div className="book-tile-actions">
                                <Link to="/books/study" className="book-tile-action primary">
                                    Jump into exercise
                                </Link>
                                <Link to="/books" className="book-tile-action secondary">
                                    View details
                                </Link>
                            </div>
                        </li>
                    </ul>
                </>
            )}
            {manualSets.length > 0 && (
                <>
                    {hasBooks && <h2 className="set-list-section">Sets</h2>}
                    <ul>
                        {manualSets.map(set =>
                            (
                                <li key={set.setId}>
                                    <Link to={`/sets/${set.setId}`}>
                                        <h2>{set.title}</h2>
                                        <p>{set.description}</p>
                                        {set.progress && <ProgressBar {...set.progress} />}
                                    </Link>
                                </li>
                            ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default SetList;
